import { render, staticRenderFns } from "./AddProductVariable.vue?vue&type=template&id=940e2f10&"
import script from "./AddProductVariable.vue?vue&type=script&lang=js&"
export * from "./AddProductVariable.vue?vue&type=script&lang=js&"
import style0 from "./AddProductVariable.vue?vue&type=style&index=0&id=940e2f10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports